import { render, staticRenderFns } from "./CommentVideoList.vue?vue&type=template&id=45665e9d&scoped=true&"
import script from "./CommentVideoList.vue?vue&type=script&lang=js&"
export * from "./CommentVideoList.vue?vue&type=script&lang=js&"
import style0 from "./CommentVideoList.vue?vue&type=style&index=0&id=45665e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45665e9d",
  null
  
)

component.options.__file = "CommentVideoList.vue"
export default component.exports